
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 4800 2400"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#f9cf02"}},[_c('g',{attrs:{"transform":"scale(5)"}},[_c('path',{attrs:{"fill":"#c4272f","d":"M0 0h960v480H0z"}}),_c('path',{attrs:{"fill":"#015197","d":"M320 0h320v480H320z"}}),_c('circle',{attrs:{"cx":"160","cy":"164","r":"44"}}),_c('circle',{attrs:{"cx":"160","cy":"144","r":"48","fill":"#c4272f"}}),_c('circle',{attrs:{"cx":"160","cy":"152","r":"32"}}),_c('path',{attrs:{"d":"M140 92a20 20 0 0040 0c0-8-5-9-5-12s3-7-3-12c3 5-2 6-2 11s2 5 2 9a4 4 0 01-8 0c0-4 4-8 4-14s-1-8-4-13-8-9-4-13c-6 2-3 10-3 15s-4 8-4 14 3 7 3 11a4 4 0 01-8 0c0-4 2-4 2-9s-5-6-2-11c-6 5-3 9-3 12s-5 4-5 12zM72 216v192h40V216zm136 0v192h40V216zm-88 32v16h80v-16zm0 112v16h80v-16zm0-144h80l-40 24zm0 168h80l-40 24z"}})]),_c('g',{attrs:{"stroke":"#c4272f","stroke-width":"24"}},[_c('circle',{attrs:{"cx":"800","cy":"1560","r":"212"}}),_c('path',{attrs:{"fill":"none","d":"M800 1348a106 106 0 010 212 106 106 0 000 212"}})])]),_c('g',{attrs:{"fill":"#c4272f"}},[_c('circle',{attrs:{"cx":"800","cy":"1454","r":"40"}}),_c('circle',{attrs:{"cx":"800","cy":"1666","r":"40"}})])])
          )
        }
      }
    